import { ReactNode } from 'react'

export interface IBpTabProps {
  title: string
  counter?: string | number
  hide?: boolean
  panel?: ReactNode
  children?: ReactNode
  activeKey?: string
  /** Видна, но приглушена и не переключается */
  disabled?: boolean
}

export const BpTab = ({ children }: IBpTabProps) => {
  return <>{children}</>
}
